import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Cambia la posición del scroll al tope
  }, [pathname]);

  return null; // No necesita renderizar nada
};

export default ScrollToTop;
